<template>
  <div :title="$t('eip.nav.translate')">
    <el-switch v-model="isTranslate" size="mini" @input="changeTranslate" />
  </div>
</template>

<script>
  import { checkTranslate, stopObserve } from '@/utils/autoTranslate'

  const TRANSLATE_KEY = 'tr_auto_translate'

  export default {
    name: 'HtTranslate',
    data() {
      return {
        isTranslate: false,
      }
    },
    mounted() {
      this.getTranslateConfig()

      this.$baseEventBus.$on('update_auto_translate', this.getTranslateConfig)
    },

    beforeDestroy() {
      this.$baseEventBus.$off('update_auto_translate', this.getTranslateConfig)
    },

    methods: {
      changeTranslate(val) {
        this.setTranslateConfig(val)

        const lang = this.$i18n.locale

        if (this.isTranslate) {
          checkTranslate(lang.slice(0, 2))
        } else {
          // 关闭翻译
          stopObserve()
        }
      },

      setTranslateConfig(val) {
        localStorage.setItem(TRANSLATE_KEY, val ? '1' : '0')
      },

      getTranslateConfig() {
        this.isTranslate = localStorage.getItem(TRANSLATE_KEY) === '1'
      },
    },
  }
</script>
